// extracted by css-extract-rspack-plugin
export default {"colorIndicator":"IssueFieldLeadingVisual-module__colorIndicator__TmLnb"};